import MessagesBlock from './messages-block'
export default MessagesBlock
